export default __webpack_public_path__ + "static/SVGTotalPPC-6c05a5bb516158720998e2c4bc69c9ef.svg";